import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource";
import {
  getCustomerDesignations,
  getCustomerDesignation,
  createCustomerDesignation,
  editCustomerDesignation,
  deleteCustomerDesignation,
  getAllCustomerDesignations,
  getTrashedCustomerDesignations,
  restoreCustomerDesignation,
} from "api/customerDesignationApi";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const CUSTOMER_DESIGNATION_QUERY_KEY = "customer-designations"
export const CUSTOMER_DESIGNATION_GROUP_QUERY_KEY = "customer-designations-group"

// -------------------- FETCH PAGINATED --------------------
export const useCustomerDesignations = (params = {}, enabled = true) => {
  return usePaginatedResource(
    CUSTOMER_DESIGNATION_QUERY_KEY,
    getCustomerDesignations,
    params,
    enabled
  )
}

// -------------------- FETCH SINGLE ITEM --------------------
export const useCustomerDesignation = (id, enabled = true) => {
  return useResourceItem(
    CUSTOMER_DESIGNATION_QUERY_KEY,
    getCustomerDesignation,
    id,
    enabled
  )
}

// -------------------- CREATE --------------------
export const useCreateCustomerDesignation = () => {
  return useCreateResource(
    createCustomerDesignation,
    CUSTOMER_DESIGNATION_QUERY_KEY
  )
}

// -------------------- EDIT --------------------
export const useEditCustomerDesignation = () => {
  return useEditResource(
    editCustomerDesignation,
    CUSTOMER_DESIGNATION_QUERY_KEY
  )
}

// -------------------- DELETE --------------------
export const useDeleteCustomerDesignation = () => {
  return useDeleteResource(
    deleteCustomerDesignation,
    CUSTOMER_DESIGNATION_QUERY_KEY
  )
}

// -------------------- ADDITIONAL --------------------

// Get all customer designations without pagination
export const useAllCustomerDesignations = (params = {}) => {
  return usePaginatedResource(
    CUSTOMER_DESIGNATION_QUERY_KEY,
    getAllCustomerDesignations,
    { ...params, all: true },
    true
  )
}

// Get trashed customer designations
export const useTrashedCustomerDesignations = (params = {}) => {
  return usePaginatedResource(
    CUSTOMER_DESIGNATION_QUERY_KEY,
    getTrashedCustomerDesignations,
    params,
    true
  )
}

// Restore a trashed customer designation
export const useRestoreCustomerDesignation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: restoreCustomerDesignation,
    onSuccess: (res, { id }) => {
      const restoredItem = res?.data
      if (!restoredItem) return

      // Update paginated cache
      queryClient.setQueriesData([CUSTOMER_DESIGNATION_QUERY_KEY, "all"], old => {
        if (!old || !old.data || !Array.isArray(old.data.data)) return old
        const updated = structuredClone(old)
        updated.data.data = [restoredItem, ...updated.data.data]
        updated.data.total = (updated.data.total || 0) + 1
        return updated
      })

      // Update individual item cache
      queryClient.setQueryData([CUSTOMER_DESIGNATION_QUERY_KEY, id], restoredItem)
    },
  })
}
